module.exports = __webpack_public_path__ + "5050a67deba3c13b961a1155b68f3e5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/4.jpg
// module id = 228
// module chunks = 0